(function () {
  'use strict';

  if (customElements.get('pdp-alma')) return;

  var POLL_INTERVAL = 150;
  var POLL_TIMEOUT = 10000;
  var MIN_AMOUNT = 10000;

  class PdpAlma extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pdp-alma]');
      this.container = this.querySelector('[data-pdp-alma-modal]');
      if (!this.button || !this.container) return;

      this.price = parseInt(this.dataset.price, 10);
      if (!this.price || this.price < MIN_AMOUNT) {
        this.hidden = true;
        return;
      }

      this._waitForAlma();
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
    }

    _waitForAlma() {
      var self = this;
      var elapsed = 0;
      this._timer = setInterval(function () {
        elapsed += POLL_INTERVAL;
        if (window.Alma && window.Alma.Widgets && window.ALMA_MERCHANT_ID) {
          clearInterval(self._timer);
          self._init();
        } else if (elapsed >= POLL_TIMEOUT) {
          clearInterval(self._timer);
        }
      }, POLL_INTERVAL);
    }

    _init() {
      try {
        var mode = window.ALMA_WIDGET_MODE === 'test' ? Alma.ApiMode.TEST : Alma.ApiMode.LIVE;
        var widgets = Alma.Widgets.initialize(window.ALMA_MERCHANT_ID, mode);
        widgets.add(Alma.Widgets.Modal, {
          container: '#' + this.container.id,
          purchaseAmount: this.price,
          locale: 'fr',
          clickableSelector: '#' + this.button.id,
        });
        this._updateAmount();
        this.classList.add('pdp-alma--ready');
      } catch (error) {
      }
    }

    _updateAmount() {
      var label = this.querySelector('[data-pdp-alma-amount]');
      if (!label || !window.ALMA_FEE_PLANS) return;

      var plans = window.ALMA_FEE_PLANS;
      if (typeof plans === 'string') {
        try {
          plans = JSON.parse(plans);
        } catch (error) {
          return;
        }
      }

      var installments = 0;
      for (var key in plans) {
        var plan = plans[key];
        var parts = key.split('_');
        var count = parseInt(parts[1], 10);
        var deferred = parseInt(parts[2], 10) || parseInt(parts[3], 10) || 0;
        var min = parseInt(plan.min_purchase_amount, 10) || 0;
        var max = parseInt(plan.max_purchase_amount, 10) || Infinity;
        if (String(plan.is_enabled).toLowerCase() !== 'true') continue;
        if (count < 2 || deferred > 0) continue;
        if (this.price < min || this.price > max) continue;
        if (count > installments) installments = count;
      }
      if (!installments) return;

      var amount = Math.floor(this.price / installments);
      label.textContent = 'À partir de ' + Alma.Utils.formatCents(amount) + ' €';
    }
  }

  customElements.define('pdp-alma', PdpAlma);
})();
